<template>
  <el-button :type="type" :class="iconClass" :size="size" @click="on_query" ref="me" :loading="is_loading">
    <span class="ml-1">{{ label }}</span>
  </el-button>
</template>

<script>
// -- import * as _ from "lodash-es"

export default {
  components: {},
  props: {
    size: { type: String, default: () => "small" },
    type: { type: String, default: () => "primary" },
    label: { type: String, default: () => "query" },
    iconClass: { type: String, default: () => "iconfont icon-search" },
  },
  data() {
    return {
      is_loading: false,
    }
  },
  methods: {
    on_query: _.debounce(
      function () {
        if (this.is_loading === true) return
        this.is_loading = true
        this.$emit("on_query", () => (this.is_loading = false))
      },
      1000,
      { leading: false, trailing: true }
    ),
  },
}
</script>
